<template>
  <div>
    <v-card>
      <v-card-title>
        <v-flex d-flex lg4>
          <center><img src="archivos/logo.png" width="100%"/></center>
        </v-flex>
      </v-card-title>
    </v-card>
    <v-card>
      <v-card-title>
        <span class="headline">Resultados</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <table style="width: 100%">
            <thead>
              <tr align="left">
                <th>Código</th>
                <th>DNI</th>
                <th>Alumno</th>
                <th>Correctas</th>
                <th>Incorrectas</th>
                <th>En Blanco</th>
                <th>Hora Final</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><v-text-field label="Código" name="codigo" id="codigo" mask="########" size="8" v-model="registro.codigo" v-on:keyup="buscarAlumno(0)"/></td>
                <td><v-text-field label="DNI" name="dni" id="dni" mask="########" size="8" v-model="registro.dni" v-on:keyup="buscarAlumno(1)"/></td>
                <td>{{ registro.alumno }}</td>
                <td><v-text-field label="Correctas" ref="buenas" name="buenas" id="buenas" mask="##" size="2" v-model="registro.buenas" v-on:keyup="calcularRespuestas()"/></td>
                <td><v-text-field label="Incorrectas" ref="malas" name="malas" id="malas" mask="##" size="2" v-model="registro.malas" v-on:keyup="calcularRespuestas()"/></td>
                <td>{{ registro.vacias }}</td>
                <td><v-text-field label="Hora final" ref="hora_fin" name="hora_fin" id="hora_fin" mask="##:##:##" size="2" v-model="registro.horaFin" v-on:keyup="calcularRespuestas()"/></td>
                <td><v-btn color="primary" @click.native="guardar">Guardar</v-btn><v-btn color="primary" @click.native="editar" v-if="registro.id !== undefined && registro.id !== 0 && usuarioApp.toUpperCase() === 'ADMINSAN'">Modificar</v-btn></td>
              </tr>
            </tbody>
          </table>
          <br />
          <br /><br />
        </v-container>
      </v-card-text>
      <v-card-actions>
      </v-card-actions>
    </v-card>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: () => ({
    dialog: false,
    disabledRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    headers: [],
    datos: [],
    registro: {},
    lista: {},
    voucherURL: '',
    voucherArchivo: ''
  }),
  computed: {
    computedCierreFecha () {
      return this.formatoFecha(this.registro.cierreFecha)
    }
  },
  watch: {
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    buscarAlumno (campo) {
      if (campo === 1) this.registro.codigo = ''
      else this.registro.dni = ''
      if (('codigo' in this.registro && this.registro.codigo.length >= 8) || ('dni' in this.registro && this.registro.dni.length === 8)) {
        var solicitudApi = this.crearSolicitud()
        solicitudApi.datos = {codigo: this.registro.codigo, dni: this.registro.dni}
        const myRequest = new Request(`${process.env.API}inicio.php?mod=resultados&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.l === false) {
              this.$emit('login', datos.m)
            } else {
              if (datos.e === 1) {
                this.registro = datos.d
                this.$refs.buenas.focus()
              }
            }
          })
      } else {
        this.registro.alumno = ''
        this.registro.buenas = ''
        this.registro.malas = ''
        this.registro.vacias = ''
        this.registro.horaFin = ''
      }
    },
    calcularRespuestas () {
      if (parseInt(this.registro.buenas) === this.registro.totalPreguntas) {
        this.registro.malas = '00'
      }
      if (this.registro.buenas.length > 1 && this.registro.malas.length < 1) {
        this.$refs.malas.focus()
      } else if (this.registro.buenas.length > 1 && this.registro.malas.length > 1 && this.registro.horaFin.length < 1) {
        this.$refs.hora_fin.focus()
      }
      this.registro.vacias = (this.registro.totalPreguntas - parseInt(this.registro.buenas) - parseInt(this.registro.malas))
      this.$forceUpdate()
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    guardar () {
      if (this.registro.codigo === undefined || this.registro.buenas === undefined || this.registro.malas === undefined || this.registro.horaFin === undefined) {
        alert('Debe llenar la cantidad de respuestas')
        return
      }
      if (this.registro.buenas.length <= 0 || this.registro.malas.length <= 0 || this.registro.horaFin.length <= 3) {
        alert('Debe llenar la cantidad de respuestas')
        return
      }
      if ((parseInt(this.registro.buenas) + 0 + parseInt(this.registro.malas)) > parseInt(this.registro.totalPreguntas)) {
        alert('Error en respuestas')
        return
      }
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=resultados&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.registro = {}
            } else {
              alert(datos.m)
            }
          }
        })
    },
    editar () {
      if (this.registro.codigo === undefined || this.registro.buenas === undefined || this.registro.malas === undefined || this.registro.horaFin === undefined) {
        alert('Debe llenar la cantidad de respuestas')
        return
      }
      if (this.registro.buenas.length <= 0 || this.registro.malas.length <= 0 || this.registro.horaFin.length <= 3) {
        alert('Debe llenar la cantidad de respuestas')
        return
      }
      if ((parseInt(this.registro.buenas) + 0 + parseInt(this.registro.malas)) > parseInt(this.registro.totalPreguntas)) {
        alert('Error en respuestas')
        return
      }
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=resultados&accion=editar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.registro = {}
            } else {
              alert(datos.m)
            }
          }
        })
    },
    subirVoucher () {
      this.$refs.image.click()
    },
    registrarVoucher (url, archivo) {
      this.voucherURL = url
      this.registro.voucher = encodeURIComponent(url)
      this.voucherArchivo = archivo
    },
    mostrarVoucher (archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo)
      }
      return ''
    },
    onSubirVoucher (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          var img = document.createElement('img')
          img.src = fr.result
          img.addEventListener('load', () => {
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)

            var MAX_WIDTH = 400
            var MAX_HEIGHT = 400
            var width = img.width
            var height = img.height

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            this.registrarVoucher(canvas.toDataURL(files[0].type), files[0])
          })
        })
      } else {
        this.voucherArchivo = ''
        this.voucherURL = ''
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Resultados.vue